import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { bp } from 'Styles/helpers';
import screen from 'superior-mq';
import { rgba } from 'polished';

const DonateOption = ({
  field,
  field: { name, value, onBlur },
  id,
  label,
  onChange,
  isDisabled,
  ...props
}) => (
  <DonateWrap styles={props.styles}>
    <StyledInput
      disabled={isDisabled}
      name={name}
      id={id}
      type="radio"
      value={id}
      checked={id === value}
      onChange={onChange || field.onChange}
      onBlur={onBlur}
      {...props}
    />
    <label htmlFor={id}>{label}</label>
  </DonateWrap>
);

const DonateWrap = styled.div`
  display: inline-block;

  ${screen.below(bp.portrait, `
    grid-column: span 3;
    text-align: center;
  `)};

  ${screen.below(bp.mobileSm, `
    grid-column: span 6;
  `)};

  ${props => props.styles && css`
    ${props.styles}
  `}
`;

const StyledInput = styled.input`
  &[type="radio"]:checked,
  &[type="radio"]:not(:checked) {
    position: absolute;
    left: -9999px;
  }

  &[type="radio"] + label {
    position: relative;
    cursor: pointer;
    display: block;
    color: ${props => props.isDark ? '#808080' : rgba(props.theme.blue, 0.6)};
    padding: 0 16px;
    line-height: 38px;
    transition: color .3s ease;
    z-index: 1;
  }

  &[type="radio"] + label::before,
  &[type="radio"] + label::after {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: transparent;
  }

  &[type="radio"] + label::before {
    left: 0;
    top: 0;
    border: 1px solid rgba(255, 255, 255, .2);

    ${props => props.isDark && css`
      color: #808080;
      border-color: ${rgba(props.theme.blue, 0.4)};
    `}
  }

  &[type="radio"] + label::after {
    left: 0;
    top: 0;
    background-color: ${props => props.theme.blue};
    transition: all .3s ease;
    z-index: -1;
  }

  &[type="radio"]:checked + label::before,
  &[type="radio"]:hover:not(:disabled) + label::before {
    border-color: rgba(255,255,255, 0);
  }

  &[type="radio"]:checked + label,
  &[type="radio"]:hover:not(:disabled) + label {
    color: #fff;
  }

  &[type="radio"]:not(:checked) + label::after {
    opacity: 0;
  }

  &[type="radio"]:checked + label::after,
  &[type="radio"]:hover:not(:disabled) + label::after {
    opacity: 1;
  }
`;

DonateOption.propTypes = {
  field: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
  }),
  wrapStyles: PropTypes.string,
  id: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func,
};

export default DonateOption;
